import { useTranslation } from "react-i18next";
import { Button } from "../../../components/ui/button/index.js";
import { connectStepFooterAction } from "./add-phone-wizard-state.js";

export function AddPhoneConnectFooter(props: {
  busy: boolean;
  registrationAttemptFailed: boolean;
  errorCode: string | null;
  disabled: boolean;
  onRetry: () => void;
}): React.JSX.Element | null {
  const { t } = useTranslation();
  const action = connectStepFooterAction({
    busy: props.busy,
    registrationAttemptFailed: props.registrationAttemptFailed,
    errorCode: props.errorCode,
  });
  if (action !== "retry") {
    return null;
  }
  return (
    <Button
      variant="outline"
      data-testid="add-phone-register-retry"
      disabled={props.disabled}
      onClick={props.onRetry}
    >
      {t("whatsapp.retry")}
    </Button>
  );
}
